// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-form-wrapper[data-v-d4430f3a] {\n    max-width: 30rem !important;\n    border-radius: 3px;\n    border: 1px solid var(--v-form-border-base);\n    border-width: 1px 2px 2px 1px; /* shadow effect on container */\n    padding: 3rem;\n    margin: 0 auto; /* horizontally centre the div inside the parent container */\n}\n.login-logo[data-v-d4430f3a] {\n    max-width: 424px !important;\n}\n", ""]);
// Exports
module.exports = exports;
